import { Col, Row } from 'antd'

import { CriminalRecordsType } from 'shared/components/CreditAndBackgroundCheck/interfaces'
import { Statistic } from 'shared/components/CreditAndBackgroundCheck/styled'
import { getFailedReportMessage } from 'shared/components/CreditAndBackgroundCheck/utils'
import { isCriminalReportPending } from 'shared/components/CreditAndBackgroundCheck/utils/reportStatusHelpers'
import PendingStatusCard from 'shared/components/CreditAndBackgroundCheck/components/PendingStatusCard'
import Spacer from 'shared/components/Spacer'
import Tile from 'shared/components/Tile'

import { formatDate, getValueOrNA, yesNo } from 'shared/utils/ui'

type CriminalRecordsSummaryProps = {
	criminalRecords?: CriminalRecordsType
	hideCriminalRecords: boolean
}

const CriminalRecordsSummary = ({
	criminalRecords,
	hideCriminalRecords,
}: CriminalRecordsSummaryProps) => {
	const failedStateCriminalReportMessage = getFailedReportMessage(criminalRecords)
	const criminalRecordState = `State ${criminalRecords?.lastRecordState}, `

	if (hideCriminalRecords || failedStateCriminalReportMessage) {
		return null
	}

	return (
		<Row gutter={14} type="flex">
			<Col xs={24} md={12} xl={8}>
				<Tile equalHeight>
					<Tile.Inner>
						<h2>State Criminal Records</h2>
						<Spacer />
						{isCriminalReportPending(criminalRecords) ? (
							<PendingStatusCard message="Criminal background check is being processed" />
						) : (
							criminalRecords?.lastRecord && (
								<>
									<Tile.Label>Last Record</Tile.Label>
									<strong data-testid="last-record-state">{criminalRecordState}</strong>
									<span data-testid="last-record-date">
										{formatDate(criminalRecords?.lastRecord?.date)}
									</span>
									<Tile.Label data-testid="last-record-type">
										{criminalRecords?.lastRecord?.type}
									</Tile.Label>
									<Tile.Label noMb data-testid="last-record-outcome">
										{criminalRecords?.lastRecord?.outcome}
									</Tile.Label>
								</>
							)
						)}
						{!isCriminalReportPending(criminalRecords) && (
							<>
								<Spacer size={Spacer.SIZES.md} />
								<Row>
									<Col xs={8}>
										<Tile.Label>States</Tile.Label>
										<Statistic bold data-testid="criminal-record-state-count">
											{criminalRecords?.states}
										</Statistic>
									</Col>
									<Col xs={8}>
										<Tile.Label>Records</Tile.Label>
										<Statistic data-testid="criminal-record-count">
											{criminalRecords?.totalRecords}
										</Statistic>
									</Col>
									<Col xs={8}>
										<Tile.Label>Sexual Crime</Tile.Label>
										<Statistic data-testid="sexual-crime">
											{yesNo(criminalRecords?.sexualCrime)}
										</Statistic>
									</Col>
									<Col xs={8}>
										<Spacer />
										<Tile.Label>Biggest Severity</Tile.Label>
										<Statistic data-testid="criminal-record-biggest-severity">
											{getValueOrNA(criminalRecords?.biggestSeverity)}
										</Statistic>
									</Col>
									<Col xs={8}>
										<Spacer />
										<Tile.Label>Felony</Tile.Label>
										<Statistic data-testid="criminal-record-felony">
											{yesNo(criminalRecords?.felony)}
										</Statistic>
									</Col>
								</Row>
							</>
						)}
					</Tile.Inner>
				</Tile>
			</Col>
		</Row>
	)
}

export default CriminalRecordsSummary